import React from 'react';
import styles from './Item.module.scss';

const TimelineItem = ({ children }) => {
  return (
    <li data-testid={'timeline-item'} className={styles.container}>
      <span className={styles.timelineDot} />
      <div className={styles.item}>{children}</div>
    </li>
  );
};

export default TimelineItem;
